import {useAuth} from "react-oidc-context";

/**
 * Hook que proporciona funciones para verificar roles y scopes del usuario autenticado.
 */
export const useAuthPermissions = () => {
  const auth = useAuth();
  const {isAuthenticated, user} = auth;

  /**
   * Verifica si el usuario tiene al menos uno de los roles indicados.
   * @param {string | string[]} roleToVerify
   * @returns {boolean}
   */
  const verifyRole = (roleToVerify) => {
    const roles = user?.access_token ? JSON.parse(atob(user.access_token.split(".")[1])).roles : null;
    if (!isAuthenticated || !roles) return false;

    const rolesToVerify = Array.isArray(roleToVerify) ? roleToVerify : [roleToVerify];

    if (Array.isArray(roles)) {
      return rolesToVerify.some((role) =>
        roles.some((userRole) => typeof userRole === "string" && userRole.toLowerCase() === role.toLowerCase())
      );
    }

    return false;
  };

  /**
   * Verifica si el usuario tiene al menos uno de los scopes indicados.
   * @param {string | string[]} scopeToVerify
   * @returns {boolean}
   */
  const verifyScope = (scopeToVerify) => {
    const scopes = user?.access_token ? JSON.parse(atob(user.access_token.split(".")[1])).scope : null;
    if (!isAuthenticated || !user?.scope) return false;

    const scopesToVerify = Array.isArray(scopeToVerify) ? scopeToVerify : [scopeToVerify];
    if (scopes && Array.isArray(scopes)) {
      return scopesToVerify.some((scope) =>
        scopes.some((userScope) => typeof userScope === "string" && userScope.toLowerCase() === scope.toLowerCase())
      );
    }

    return false;
  };

  return {verifyRole, verifyScope};
};
